<div class="row col-12 p-0 m-0 main-page-section ">

  <div class="col-12 p-0 container-fluid reports-section">



    <div class="col-height">


      <div class="breadcrumbs-section padding-report">
        <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
        <span class="separator">&nbsp; > &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">Reports</span>
      </div>



      <div class="d-flex justify-content-between padding-report-heading pb-3 pl-5 ml-2">
        <div class="meeting-room-report pointer-link col-9" (clickOutside)="onClickedOutside($event)"
          [autoClose]="'outside'" [ngbPopover]="popContent" triggers="manual" #pr="ngbPopover" (click)="openPopover(pr)"
          placement="bottom" popoverClass='dash-popover dashboard-popover'>
          <span *ngIf="selectedIndex==2">Events Report</span>
          <span *ngIf="selectedIndex==1">VMS Report</span>
          <span *ngIf="selectedIndex==0">Frie Warden Report - Company</span>
          <img src="../../assets/images/Path.png" class="padding-left-image pr-1" loading="lazy" />
        </div>
        <div>
          <ng-template #popContent>
            <div class="dashboard-popover ">
              <div class="">
                <div class="">
                  <div class="row pb-3 d-flex justify-content-between pointer-link"
                    *ngFor="let report of reportsList;let i=index"
                    (click)="selectedReportType(report.index);openPopover(pr)">
                    <div class="popover-content pl-3 email-width" [class]="selectedIndex==i?'bold-font':'normal-font'">
                      {{report.type}}
                    </div>
                    <div>
                      <img src="/assets/images/tick.png" *ngIf="selectedIndex==i" class="pl-5 " loading="lazy" />
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </ng-template>
        </div>

        <div class="col-3" [ngbPopover]="popDownloadContent" triggers="manual" #pd="ngbPopover"
          (click)="openPopover(pd)" popoverClass='dnload-popover download-popover'>
          <button type="button " class="add-button"><span class="add">Download
              Report&nbsp;&nbsp; &#9660;</span></button>
        </div>

        <div>
          <ng-template #popDownloadContent>
            <div class="download-popover">
              <div class="">
                <div class="">
                  <div class="row pb-3 d-flex justify-content-between pointer-link"
                    *ngFor="let downloadTypes of DownloadTypes"
                    (click)="selectedReportDownload(downloadTypes);openPopover(pd)">
                    <div class="popover-content pl-3 email-width">
                      {{downloadTypes.type}}
                    </div>
                    <div>
                      <!-- <img src="/assets/images/tick.png"
                        *ngIf="SelectedDownloadReportType.includes(downloadTypes.id) || (downloadTypes.id == null && SelectedDownloadReportType.length == 0)"
                        class="pl-5 " loading="lazy" /> -->
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </ng-template>
        </div>
      </div>




      <div class="col-12 d-flex  row borders m-0 p-0 ">
        <div class="col-3  borders-right d-flex justify-content-between relative-content ml-5" *ngIf="selectedIndex!=0">
          <div class="pt-3 pb-3" *ngIf="selectedIndex==1" (clickOutside)="onClickedOutside($event)"
            [autoClose]="'outside'" [ngbPopover]="popInviteType" triggers="manual" #p0="ngbPopover"
            (click)="openPopover(p0)" placement="bottom" popoverClass='dash-popover dashboard-popover'
            class="meeting-label center-align box-size pointer-link text-center usage-for">
            <div class="text">Invite Type</div>

            <div class="meeting-sub-label">{{selectedInviteType}} <img src="/assets/images/Path.png"
                class=" pr-3 access-point-arrow" loading="lazy" /></div>

            <div>
              <ng-template #popInviteType>
                <div class="dashboard-popover ">
                  <div class="">
                    <div class="">
                      <div class="row pb-3 d-flex justify-content-between pointer-link"
                      *ngFor="let invite of invitationTypes;let i=index"
                        (click)="selectInviteType(invite);openPopover(p0)">
                        <div class="popover-content pl-3 email-width"
                         [class]="multiSelectionInvitationType.includes(invite?.invitationTypeId) ?'bold-font':'normal-font'">
                          {{invite.invitationType}}
                        </div>
                        <div>
                          <img src="/assets/images/tick.png"
                            *ngIf="multiSelectionInvitationType.includes(invite.invitationTypeId) || (invite.invitationTypeId == null && multiSelectionInvitationType.length == 0)"
                            class="pl-5 " loading="lazy" />
                        </div>
                        <div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </ng-template>
            </div>

          </div>

          <div class="pt-3 pb-3" *ngIf="selectedIndex==2" (clickOutside)="onClickedOutside($event)"
            [autoClose]="'outside'" [ngbPopover]="popEventCat" triggers="manual" #p0="ngbPopover"
            (click)="openPopover(p0)" placement="bottom" popoverClass='dash-popover dashboard-popover'
            class="meeting-label center-align box-size pointer-link text-center usage-for">
            <div class="text">Event Category</div>

            <div class="meeting-sub-label">{{selectedEventCat}} <img src="/assets/images/Path.png"
                class=" pr-3 access-point-arrow" loading="lazy" /></div>

            <div>
              <ng-template #popEventCat>
                <div class="dashboard-popover ">
                  <div class="">
                    <div class="">
                      <div class="row pb-3 d-flex justify-content-between pointer-link"
                        *ngFor="let cat of eventCategory  ;let i=index" (click)="selectEventCat(cat);openPopover(p0)">
                        <div class="popover-content pl-3 email-width">
                          {{cat.name}}
                        </div>
                        <div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

              </ng-template>
            </div>

          </div>
        </div>


        <div class=" pt-3 pb-3 borders-right col-2 ">

          <div class="pl-3">
            <span class="meeting-label pt-3" style="
                        position: absolute;
                        padding-left: 31px;margin-top: -14px;">From</span>

            <input class="cal-icon all-hosts pt-3  pointer-link" (click)="d1.toggle()" [(ngModel)]="fDate" ngbDatepicker
              #d1="ngbDatepicker" (dateSelect)="updateSelectedDate($event)">


            <div class="meeting-sub-label from-date">{{formattedSelectedDate}}</div>

          </div>

        </div>
        <div class="pl-3 pt-3 pb-3 col-2 borders-right  ">
          <span class="meeting-label pt-3" style="
                        position: absolute;
                        padding-left: 31px;margin-top: -14px;">To</span>
          <input class="cal-icon all-hosts pt-3  pointer-link" (click)="d2.toggle()" [(ngModel)]="tDate" ngbDatepicker
            #d2="ngbDatepicker" (dateSelect)="updateSelectedToDate($event)">
          <div class="meeting-sub-label from-date">{{formattedSelectedToDate}}</div>

        </div>
        <div [ngClass]="'col-4'">
          <label for="search">
            <img loading="lazy" [ngClass]="selectedIndex==0?'image-pos-credit':'image-pos'" class=" search-layout"
              src="/assets/images/search.png" alt="search" style="left:auto !important">
            <input class="search-box search-padding placeholder-text " type="text" name="search" id="menu-search"
              [(ngModel)]="searchText" placeholder="Type here to search…">
          </label>
        </div>

      </div>

      <label class="padding-report pt-2 pb-2 column-data" style="margin-top: 10px;">
        {{totalRows}} results found for you
      </label>
      <empty-state
      *ngIf="reportsLoaded && (  selectedIndex==1 && vmsList.length == 0 )">
    </empty-state>

    </div>


    <div class="scroll-content " id="content" #content *ngIf="selectedIndex==0 && fireWardenList.length > 0"
      [ngClass]="{'horizontal-scrollable': fireWardenList.length>0}">
      <table class="table table-borderless table-curved   " *ngIf="fireWardenList.length > 0" id="pdfTable" #pdfTable>
        <thead>
          <tr>
            <th scope="col-2" style="text-align: center;"> Sr.No<img loading="lazy" class="pl-2"
                src="/assets/images/sort.png" alt="search" (click)="sort('srNo',fireWardenList)"></th>
            <th scope="col">ERT Member name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('ertName',fireWardenList)"></th>
            <th scope="col">Scanned Employee Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('scannedEmployeeName',fireWardenList)"></th>
            <th scope="col">Scan Date <img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('scannedDate',fireWardenList)"></th>
            <th scope="col">Scan Time <img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('scannedTime',fireWardenList)"></th>
            <th scope="col">Scanned Employee Email<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('employeeEmail',fireWardenList)"></th>
            <th scope="col">Scanned Employee Mobile Number<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('employeeMobile',fireWardenList)"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let fireWard of fireWardenList | filter:searchText  | paginate: { itemsPerPage: 10,
          currentPage: page,
          totalItems:fireWardenList.length }; let i=index " [ngClass]="i%2!=0?'row-even':'row-odd'">
            <td style="color:rgba(64,64,64,0.6) ; text-align: center;">{{i+1}}</td>
            <td>{{fireWard.ertMbrName}}</td>
            <td>{{fireWard.scannedEmployeeName}}</td>
            <td>{{fireWard.scannedDate}}</td>
            <td>{{fireWard.scannedTime}}</td>
            <td>{{fireWard.employeeEmail }}</td>
            <td>{{fireWard.mobileNumber}}</td>
          </tr>
        </tbody>
      </table>
    </div>



    <div class="scroll-content " id="content" #content *ngIf="selectedIndex==1 && vmsList.length > 0"
      [ngClass]="{'horizontal-scrollable': vmsList.length>0}">
      <table class="table table-borderless table-curved   " *ngIf="vmsList.length > 0" id="pdfTable" #pdfTable>
        <thead>
          <tr>
            <th scope="col-2" style="text-align: center;"> Sr.No<img loading="lazy" class="pl-2"
                src="/assets/images/sort.png" alt="search" (click)="sort('srNo',vmsList)"></th>
            <th scope="col">System Record Id<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('systemRecordId',vmsList)"></th>
            <th scope="col">Visitor Company<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('visitorCompany',vmsList)"></th>
            <th scope="col">Visitor Name <img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('visitorName',vmsList)"></th>
            <th scope="col">Visitor Mobile No <img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('visitorMobileNumber',vmsList)"></th>

            <th scope="col">Visitor Email<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('visitorEmail',vmsList)"></th>
            <th scope="col">Date of Visit<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('dateOfVisit',vmsList)"></th>
            <th scope="col">Time of Visit<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('timeIn',vmsList)"></th>
            <th scope="col">Host Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('hostName',vmsList)"></th>
            <th scope="col">Host Mobile no<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('hostMobileno',vmsList)"></th>
            <th scope="col">Host Email<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('hostEmail',vmsList)"></th>
            <th scope="col">Park Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('parkName',vmsList)"></th>
            <th scope="col">Building<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('building ',vmsList)"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let vms of vmsList | filter:searchText  | paginate: { id: 'vms-report', itemsPerPage: 10,
          currentPage: page,
          totalItems: searchText?.trim() ? (vmsList | filter:searchText).length : vmsList.length }; let i=index " [ngClass]="i%2!=0?'row-even':'row-odd'">
            <td style="color:rgba(64,64,64,0.6) ; text-align: center;">{{i+1}}</td>
            <td>{{vms.systemRecordId}}</td>
            <td>{{vms.visitorCompany}}</td>
            <td>{{vms.visitorName}}</td>
            <td>{{vms.visitorMobileNumber}}</td>
            <td>{{vms.visitorEmail }}</td>
            <td>{{vms.dateOfVisit}}</td>
            <td>{{vms.timeIn}}</td>
            <td>{{vms.hostName}}</td>
            <td>{{vms.hostMobileno}}</td>
            <td>{{vms.hostemail}}</td>
            <td>{{vms.parkName}}</td>
            <td>{{vms.building}}</td>

          </tr>
        </tbody>
      </table>
    </div>

    <div class="scroll-content " id="content" #content *ngIf="selectedIndex==2 && eventList.length > 0"
      [ngClass]="{'horizontal-scrollable': eventList.length>0}">
      <table class="table table-borderless table-curved   " *ngIf="eventList.length > 0" id="pdfTable" #pdfTable>
        <thead>
          <tr>
            <th scope="col-2" style="text-align: center;"> Sr.No<img loading="lazy" class="pl-2"
                src="/assets/images/sort.png" alt="search" (click)="sort('srNo',eventList)"></th>
            <th scope="col">Event Category<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('scannedEmployeeName',eventList)"></th>
            <th scope="col">Event Title <img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                  (click)="sort('ertName',eventList)"></th>
            <th scope="col">Start Date <img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('scannedTime',eventList)"></th>
            <th scope="col">End Date<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('employeeEmail',eventList)"></th>
            <th scope="col">Event Participation Type <img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                  alt="search" (click)="sort('scannedDate',eventList)"></th>
            <th scope="col">Team Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('employeeName',eventList)"></th>
            <th scope="col">Count of Participants<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('scannedDate',eventList)"></th>
            <th scope="col">Participant Captain Name<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                  (click)="sort('scannedTime',eventList)"></th>
            <th scope="col">Captain Mobile no<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('employeeEmail',eventList)"></th>
            <th scope="col">Captain Email<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('employeeMobile',eventList)"></th>
            <th scope="col">Participant Name(s)<img loading="lazy" class="pl-2" src="/assets/images/sort.png"
                alt="search" (click)="sort('employeeMobile',eventList)"></th>
            <th scope="col">Attendance<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('employeeMobile',eventList)"></th>
            <th scope="col">Feedback<img loading="lazy" class="pl-2" src="/assets/images/sort.png" alt="search"
                (click)="sort('employeeMobile',eventList)"></th>

          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let event of eventList | filter:searchText  | paginate: { itemsPerPage: 10,
          currentPage: page,
          totalItems:eventList.length }; let i=index " [ngClass]="i%2!=0?'row-even':'row-odd'">
            <td style="color:rgba(64,64,64,0.6) ; text-align: center;">{{i+1}}</td>
            <td>{{event.eventCategory}}</td>
            <td>{{event.eventTitle}}</td>
            <td>{{event.startDate}}</td>
            <td>{{event.endDate }}</td>
            <td>{{event.eventParticipantType}}</td>
            <td>{{event.teamName}}</td>
            <td>{{event.participantsCount}}</td>
            <td>{{event.captain.name}}</td>
            <td>{{event.captain.phone}}</td>
            <td>{{event.captain.email}}</td>
            <td>{{event.participants}}</td>
            <td>{{event.attendance}}</td>
            <td>{{event.feedback}}</td>
          </tr>
        </tbody>
      </table>
    </div>


    <div class="d-flex justify-content-center pagination-section"
      *ngIf="reportsLoaded && ((selectedIndex==1  ) && vmsList.length > 10)">
      <div class="row d-flex pagination-border">
        <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChangeMeeting($event)"
          nextLabel="" class="d-flex justify-content-center">
        </pagination-controls>

        <div class="pr-3 ratio-class pt-1">
          {{vmsList?.length}}/{{vmsList.length}}</div>
      </div>
    </div>

  </div>
